// Styles for SearchResultsFilterPanel go here.
import styled from 'styled-components';
import { baseVariables, toRem } from '@marriott/mi-ui-library';
import { MOBILE_NAVBAR_HEIGHT } from '../../modules/constants/constant';

export const StyledSearchResultsFilterPanel = styled.div`
  .brand-filter__category_list {
    display: grid !important;
    grid-template-columns: 1fr 1fr;
    grid-gap: ${toRem(16)};
  }

  .searchResultsFilter_panel .brand-filter__category_list {
    grid-template-columns: 1fr 1fr;

    @media only ${baseVariables.mediaQuery.md} {
      grid-template-columns: 1fr 1fr 1fr;
    }

    @media only ${baseVariables.mediaQuery.lg} {
      grid-template-columns: 1fr 1fr 1fr 1fr;
    }
  }

  .BRANDS .brand-filter__category_list {
    grid-template-columns: 1fr 1fr 1fr;

    @media only ${baseVariables.mediaQuery.lg} {
      grid-template-columns: 1fr 1fr 1fr 1fr;
    }
  }

  .brand-logo-container {
    margin: 0 !important;
    width: auto !important;
    height: auto !important;
  }

  .filter-dropdown {
    width: ${toRem(362)};
  }

  @media only ${baseVariables.mediaQuery.lg} {
    margin-top: ${toRem(4)};

    .m-dropdown-container {
      border: ${toRem(1)} solid ${baseVariables.color['neutral20']} !important;
    }

    .m-dropdown-children {
      height: 100%;
      max-height: calc(60vh - ${toRem(MOBILE_NAVBAR_HEIGHT)});
      &::-webkit-scrollbar {
        display: none;
      }
    }
  }

  .modal-clear-btn {
    border-bottom: ${toRem(1)} solid ${baseVariables.color.base10};
  }

  .m-dropdown-action-clear {
    color: ${baseVariables.color.base10};
  }

  .m-dropdown-action-bar {
    background-color: ${baseVariables.color.base20} !important;
  }

  .pill:hover,
  .pill.is-hover {
    box-shadow: none !important;
  }

  .modal-footer {
    border-radius: 0;
    height: auto;

    .apply-button {
      width: auto;
    }
  }

  .filter-dropdown {
    border-radius: ${toRem(14)};
  }

  .m-icon-text-block {
    padding: ${toRem(4)};
  }

  .region-el {
    margin: ${toRem(8)} ${toRem(12)} !important;
  }

  .LEISURE_REGIONS .m-dropdown-action-clear {
    margin: ${toRem(8)} 0;
  }

  .custom-map-dropdown button.apply-button {
    border-radius: ${toRem(20)};
  }

  .brand-filter__category_label_btn {
    min-height: ${toRem(20)};
    text-decoration: none;

    span {
      position: relative;

      &::after {
        background-color: ${baseVariables.color.base10};
        position: absolute;
        content: '';
        width: 100%;
        height: ${toRem(1)};
        top: 100%;
        left: 0;
        margin-top: ${toRem(2)};
      }
    }
  }

  .searchResultsFilter_panel .checkbox-controls-list .row {
    display: flex;
    flex-wrap: no-wrap;
    flex-direction: column;

    @media only ${baseVariables.mediaQuery.md} {
      display: flex;
      flex-wrap: wrap;
      margin-right: ${toRem(-8)};
      margin-left: ${toRem(-8)};
      flex-direction: unset;
    }
  }

  .AMENITIES .checkbox-controls-list {
    padding: 0;
  }

  .popup-header-container > .custom-scrollbar {
    max-width: none;
    margin: 0 !important;
    position: fixed;
  }

  .brand-filter {
    padding: 0 !important;
  }

  .popup-header-container .header-heading {
    font-size: ${toRem(18)};
  }

  .PROPERTY_TYPES .checkbox-controls-list {
    padding: 0 !important;
  }

  @media only ${baseVariables.mediaQuery.lg} {
    .AMENITIES,
    .ACTIVITIES,
    .BRANDS,
    .PROPERTY_TYPES {
      padding: 0 ${toRem(12)} !important;
    }
  }
`;
